import { LayoutDashboard, GraduationCap, Users, Wallet, Banknote, AlertCircle, UserCog, User, Database, Shield, ClipboardCheck } from "lucide-react";
import { BookOpen, BookCheck, Bell, MessageSquare, FileText, CalendarCheck, ClipboardList, Phone, Award, ScrollText, CalendarDays, Video } from "lucide-react";

export const NAV_ADMIN = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/profil", label: "Profil Admin", icon: User },
  { to: "/admin/profil-kepsek", label: "Profil Kepala Sekolah", icon: User },
  { to: "/admin/profil-pustaka", label: "Profil Pustaka", icon: User },
  { to: "/admin/profil-bendahara", label: "Profil Bendahara", icon: User },
  { to: "/admin/siswa", label: "Siswa", icon: GraduationCap },
  { to: "/admin/guru", label: "Guru", icon: Users },
  { to: "/admin/gaji", label: "Gaji", icon: Banknote },
  { to: "/admin/kendala", label: "Kendala", icon: AlertCircle },
  { to: "/admin/users", label: "Manajemen User", icon: UserCog },
  { to: "/admin/daftar-ulang", label: "Daftar Ulang", icon: ClipboardCheck },
  { to: "/admin/database", label: "Database & Backup", icon: Database },
  { to: "/admin/audit-log", label: "Log Aktivitas", icon: Shield },
];

export const NAV_KEPSEK = [
  { to: "/kepsek", label: "Dashboard", icon: LayoutDashboard },
  { to: "/kepsek/profil", label: "Profil", icon: User },
  { label: "Data", icon: Users, children: [
    { to: "/kepsek/data-siswa", label: "Data Siswa" },
    { to: "/kepsek/data-guru", label: "Data Guru" },
  ]},
  { label: "Administrasi", icon: Wallet, children: [
    { to: "/kepsek/admin-gaji", label: "Gaji Guru" },
    { to: "/kepsek/admin-spp", label: "Pembayaran SPP" },
    { to: "/kepsek/admin-izin", label: "Izin Guru" },
    { to: "/kepsek/laporan-keuangan", label: "Laporan Keuangan" },
    { to: "/kepsek/daftar-ulang", label: "Daftar Ulang" },
  ]},
  { label: "Tabungan Siswa", icon: Banknote, children: [
    { to: "/kepsek/tabungan/rincian", label: "Rincian Tabungan" },
    { to: "/kepsek/tabungan/saldo", label: "Saldo Tabungan" },
  ]},
  { label: "Dokumen", icon: FileText, children: [
    { to: "/kepsek/pendampingan", label: "Siswa Pendampingan" },
    { to: "/kepsek/jadwal-belajar", label: "Jadwal Belajar" },
    { to: "/kepsek/cp", label: "Capaian Pembelajaran" },
    { to: "/kepsek/modul-ajar", label: "Modul Ajar" },
    { to: "/kepsek/buku-batas", label: "Buku Batas" },
    { to: "/kepsek/nilai", label: "Nilai Siswa" },
    { to: "/kepsek/rapor", label: "Rapor" },
    { to: "/kepsek/absensi", label: "Absensi Siswa" },
    { to: "/kepsek/buku-penghubung", label: "Buku Penghubung" },
    { to: "/kepsek/evaluasi-pembelajaran", label: "Evaluasi Pembelajaran" },
  ]},
  { label: "Ekskul & Progsus", icon: Award, children: [
    { to: "/kepsek/ep-pendampingan", label: "Pendampingan" },
    { to: "/kepsek/ep-nilai", label: "Nilai" },
  ]},
  { label: "Perpustakaan", icon: BookOpen, children: [
    { to: "/kepsek/buku/fisik", label: "Daftar Buku Fisik" },
    { to: "/kepsek/buku/digital", label: "Daftar Buku Digital" },
    { to: "/kepsek/peminjaman", label: "Daftar Peminjaman" },
  ]},
  { to: "/kepsek/kendala", label: "Kendala", icon: AlertCircle },
  { to: "/kepsek/lms", label: "LMS — Pelatihan Guru", icon: Video },
  { to: "/kepsek/kalender-pendidikan", label: "Kalender Pendidikan", icon: CalendarDays },
  { to: "/kepsek/pemberitahuan", label: "Pemberitahuan", icon: Bell },
  { to: "/kepsek/saran-kritik", label: "Saran & Kritik", icon: MessageSquare },
];

export const NAV_GURU = [
  { to: "/guru", label: "Dashboard", icon: LayoutDashboard },
  { to: "/guru/profil", label: "Profil", icon: User },
  { label: "Dokumen", icon: FileText, children: [
    { to: "/guru/pendampingan", label: "Siswa Pendampingan" },
    { to: "/guru/jadwal-belajar", label: "Jadwal Belajar" },
    { to: "/guru/modul-ajar", label: "Modul Ajar" },
    { to: "/guru/cp", label: "Capaian Pembelajaran" },
    { to: "/guru/buku-batas", label: "Buku Batas" },
    { to: "/guru/buku-penghubung", label: "Buku Penghubung" },
    { to: "/guru/nilai", label: "Nilai Siswa" },
    { to: "/guru/rapor", label: "Rapor" },
    { to: "/guru/evaluasi-pembelajaran", label: "Evaluasi Pembelajaran" },
  ]},
  { label: "Ekskul & Progsus", icon: Award, children: [
    { to: "/guru/ep-pendampingan", label: "Pendampingan" },
    { to: "/guru/ep-nilai", label: "Nilai" },
  ]},
  { label: "Absen", icon: CalendarCheck, children: [
    { to: "/guru/absensi", label: "Absensi Siswa" },
    { to: "/guru/izin", label: "Izin Guru" },
  ]},
  { to: "/guru/gaji", label: "Gaji", icon: Banknote },
  { to: "/guru/lms", label: "Pelatihan LMS", icon: Video },
  { label: "Perpustakaan", icon: BookOpen, children: [
    { to: "/guru/perpustakaan/fisik", label: "Daftar Buku Fisik" },
    { to: "/guru/perpustakaan/digital", label: "Daftar Buku Digital" },
    { to: "/guru/perpustakaan/peminjaman", label: "Daftar Peminjaman Saya" },
  ]},
  { to: "/guru/kalender-pendidikan", label: "Kalender Pendidikan", icon: CalendarDays },
  { to: "/guru/pemberitahuan", label: "Pemberitahuan", icon: Bell },
  { to: "/guru/kendala", label: "Kendala", icon: AlertCircle },
];

export const NAV_ORTU = [
  { to: "/ortu", label: "Dashboard", icon: LayoutDashboard },
  { to: "/ortu/profil-siswa", label: "Profil Siswa", icon: User },
  { to: "/ortu/absensi", label: "Absensi", icon: CalendarCheck },
  { to: "/ortu/jadwal", label: "Jadwal Belajar", icon: ClipboardList },
  { to: "/ortu/buku-penghubung", label: "Buku Penghubung", icon: BookOpen },
  { to: "/ortu/perpustakaan", label: "Perpustakaan", icon: BookOpen },
  { to: "/ortu/nilai", label: "Nilai Anak", icon: Award },
  { to: "/ortu/rapor", label: "Rapor Anak", icon: ScrollText },
  { to: "/ortu/spp", label: "SPP", icon: Wallet },
  { label: "Tabungan Siswa", icon: Banknote, children: [
    { to: "/ortu/tabungan/rincian", label: "Rincian Tabungan" },
    { to: "/ortu/tabungan/saldo", label: "Saldo Tabungan" },
  ]},
  { to: "/ortu/kalender-pendidikan", label: "Kalender Pendidikan", icon: CalendarDays },
  { to: "/ortu/pemberitahuan", label: "Pemberitahuan", icon: Bell },
  { to: "/ortu/saran-kritik", label: "Saran & Kritik", icon: MessageSquare },
  { to: "/ortu/hubungi-kami", label: "Hubungi Kami", icon: Phone },
];

export const NAV_PUSTAKA = [
  { to: "/pustaka", label: "Dashboard", icon: LayoutDashboard },
  { to: "/pustaka/profil", label: "Profil", icon: User },
  { label: "Daftar Buku", icon: BookOpen, children: [
    { to: "/pustaka/buku/fisik", label: "Buku Fisik" },
    { to: "/pustaka/buku/digital", label: "Buku Digital" },
  ]},
  { to: "/pustaka/permintaan", label: "Permintaan Peminjaman", icon: AlertCircle },
  { to: "/pustaka/peminjaman", label: "Daftar Peminjaman", icon: ClipboardList },
];

export const NAV_BENDAHARA = [
  { to: "/bendahara", label: "Dashboard", icon: LayoutDashboard },
  { to: "/bendahara/profil", label: "Profil", icon: User },
  { to: "/bendahara/spp", label: "SPP", icon: Wallet },
  { to: "/bendahara/laporan-keuangan", label: "Laporan Keuangan", icon: FileText },
  { label: "Tabungan Siswa", icon: Banknote, children: [
    { to: "/bendahara/tabungan/rincian", label: "Rincian Tabungan" },
    { to: "/bendahara/tabungan/saldo", label: "Saldo Tabungan" },
  ]},
  { to: "/bendahara/pemberitahuan", label: "Pemberitahuan Ortu", icon: Bell },
];
